import { render, staticRenderFns } from "./CloudinaryUploadWidget.vue?vue&type=template&id=8c90ec9a&scoped=true&"
import script from "./CloudinaryUploadWidget.vue?vue&type=script&lang=js&"
export * from "./CloudinaryUploadWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c90ec9a",
  null
  
)

export default component.exports